import { Component, Input, OnInit, ViewChild } from "@angular/core";

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexPlotOptions,
  ApexXAxis,
} from "ng-apexcharts";

type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: "lib-basic-timeline-chart",
  templateUrl: "./basic-timeline-chart.component.html",
})
export class BasicTimelineChartComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  ngOnInit() {
    this.chartOptions = {
      series: [
        {
          data: [
            {
              x: "Sudáfrica",
              y: [
                new Date("2019-03-02").getTime(),
                new Date("2019-03-04").getTime(),
              ],
            },
            {
              x: "Argentina",
              y: [
                new Date("2019-03-02").getTime(),
                new Date("2019-03-08").getTime(),
              ],
            },
            {
              x: "Uruguay",
              y: [
                new Date("2019-03-05").getTime(),
                new Date("2019-03-12").getTime(),
              ],
            },
            {
              x: "Australia",
              y: [
                new Date("2019-03-08").getTime(),
                new Date("2019-03-18").getTime(),
              ],
            },
          ],
        },
      ],
      chart: {
        width: 500,
        height: 350,
        type: "rangeBar",
      },
      plotOptions: {
        bar: {
          horizontal: true,
        },
      },
      xaxis: {
        type: "datetime",
      },
    };
  }
}
